import styled from 'styled-components';

export const Container = styled.div`
    max-width: 990px;
    margin: 0 auto;
    padding: 1rem 0;
`

export const Table = styled.table`
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 2rem;
`

export const Th = styled.th`
    border: 1px solid #e7e6e6;
    text-align: left;
    padding: 0.5rem;
`
export const Td = styled.td`
    border: 1px solid #e7e6e6;
    text-align: left;
    padding: 0.5rem;
   
`
export const Tr = styled.tr`
    &:nth-child(even) {
        background-color: #eeeeee;
    }
`
export const CreateBtn = styled.div`
    padding: 0.75rem 1.5rem;
    border-radius: 2rem;
    background-color: #2a97a1;
        transition: all 300ms ease-in-out;
    &:hover {
        background-color: #eeeeee;
    }
`
export const DetailsBtns = styled(Td)`
    justify-content: space-between;
    width: 160px;
        transition: all 300ms ease-in-out;
    &:hover {
        color: #2a97a1;
    }
`
export const DetailsHeading = styled(Th)`
    width: 160px;
`

export const ProfileTable = styled.div`
    width: auto;
`

export const Form = styled.form`
width: auto
`
export const FormCover = styled.div`
    margin: 0 auto;
    width: 30vw;
    border:1px solid #eeeeee;
    padding: 2rem;
    text-align: left;
`

export const H1 = styled.h1`
font-size: 2rem;
    margin: 0;
`
export const H3 = styled.h3`
    font-size: 1.25rem;
    margin:0;

    `
export const FormBtn = styled.button`
    margin-top: 1rem;
    cursor: pointer;
    border:none;
    padding: 0.75rem 1.5rem;
    background-color: #2a97a1;
    transition: all 300ms ease-in-out;
    text-align: center;
    width: 100%;
    &:hover {
        background-color: #eeeeee;
    }
`
export const ListHeading = styled.div`
    margin-bottom:2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;`

export const HeadingLeft = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 1rem;`
export const SmallSpacing = styled.div`
    margin:0.25rem`
export const MediumSpacing = styled.div`
    margin: 1rem;
    `
export const Flex= styled.div`
    display: flex;
    align-items: center;
`
export const InlineLink = styled.a`
    text-decoration: underline;
 
`